import { cssColorValue, desktopCello, semanticColors, spacer16 } from '@spotify-internal/encore-web/core';
import styled from 'styled-components';

export const NavBarProfileLinkListTitle = styled.span`
  color: ${cssColorValue(semanticColors.textBase)};
  cursor: default;
  ${desktopCello};
`;

export const NavBarProfileLinkListItemsWrapper = styled.ul`
  cursor: default;
  display: flex;
  flex-direction: column;
  list-style: none;
  margin-top: ${spacer16};
  padding: 0;
`;
